// extracted by mini-css-extract-plugin
export default {"Preview":"Preview_RaovG","outer":"outer_7kFK4","inner":"inner_4ZFco"};